import { RefreshCw } from "lucide-react";
import t from "@/lang/lang";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/shared/components/ui/card";
import {
  Milestone,
  MilestoneIcon,
  Milestones,
  MilestoneStatus,
  MilestoneTitle,
} from "@/shared/bsm/core/process/components/ui/process-page-overview";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { formatDate } from "@/shared/lib/utilities/date";
import { DocumentState } from "@/services/backend/documents/types/state";
import { DocumentIconOffer } from "@/services/backend/documents/components/document-icon";
import { useProcessesProcessShowQuery } from "@/services/backend/processes/api/process-api";
import { GSMProcessKind } from "@/services/backend/processes/types/process-kind";
import { GSMServiceKind } from "@/services/backend/services/types/kinds";
import { useOmniOfferListQuery } from "@/services/backend/omni/offer/api/offer-api";

export function WrhMilestones({ processId }: { processId: string }) {
  const {
    data: process,
    isLoading,
    error,
  } = useProcessesProcessShowQuery({ id: processId });

  return (
    <Card className="pb-0">
      <CardHeader>
        <CardTitle>{t("Meilensteine")}</CardTitle>
        <CardDescription>
          {t(
            "Die Übersicht ist aktuell noch mehr illustrativ. Es wird lediglich ausgewertet ob ein entsprechendes Dokument erstellt wurde. Eine konkretere Logik wird folgen.",
          )}
        </CardDescription>
      </CardHeader>
      <CardContent>
        <RTKQueryErrorAlert error={error} />
        {isLoading && (
          <div className="flex items-center gap-2">
            <RefreshCw className="size-4 animate-spin" />
            <span>{t("Lade Meilensteine...")}</span>
          </div>
        )}
        {process && (
          <Milestones>
            {process.processKind === GSMProcessKind.Full && (
              <OfferMilestone processId={processId} />
            )}
          </Milestones>
        )}
      </CardContent>
    </Card>
  );
}

function OfferMilestone({ processId }: { processId: string }) {
  const { data } = useOmniOfferListQuery({
    serviceKind: { active: true, values: [GSMServiceKind.WRH] },
    process: { active: true, values: [processId] },
    state: { active: true, values: [DocumentState.Immutable] },
  });

  const offer = data?.items[data.items.length - 1];

  return (
    <Milestone>
      <MilestoneIcon
        icon={DocumentIconOffer}
        done={(data?.items.length ?? 0) > 0}
      />
      <MilestoneTitle>{t("Angebot versenden")}</MilestoneTitle>
      {offer && (
        <MilestoneStatus>
          {`Das letzte Angebot wurde am ${formatDate(offer.stateSetAt ?? "")} von ${offer.stateSetBy} versendet.`}
        </MilestoneStatus>
      )}
    </Milestone>
  );
}
